import Fetcher from 'services/Fetcher'
import {
  TBusinessAccountDetails,
  TBusinessAccountDocument,
  TBusinessAccountUnderwriting,
  TGenerateResolutionLinkRequest,
  TGenerateResolutionLinkResponse
} from './types'
import { HTTP_METHODS, API_DICTIONARY } from 'constants/api'
import { ResponseWithPagination, TOptionsResponse } from 'constants/types'

const fetcher = new Fetcher({})

export const getBusinessAccountDetailsRequest = async (
  moov_business_account: string
) =>
  fetcher.request<unknown, TBusinessAccountDetails>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${moov_business_account}/`,
    method: HTTP_METHODS.GET
  })

export const getCommunityAccessOptionsRequest = async () =>
  fetcher.request<unknown, TOptionsResponse[]>({
    url: `${API_DICTIONARY.COMMUNITIES}${API_DICTIONARY.HEALTH_SYSTEMS}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.COMMUNITY_ACCESS}`,
    method: HTTP_METHODS.GET
  })

export const getBusinessAccountUnderwritingRequest = async (
  moov_business_account: string
) =>
  fetcher.request<unknown, TBusinessAccountUnderwriting>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${moov_business_account}/${API_DICTIONARY.UNDERWRITING}`,
    method: HTTP_METHODS.GET
  })

export const getBusinessAccountDocumentsRequest = async (
  moov_business_account: string
) =>
  fetcher.request<unknown, ResponseWithPagination<TBusinessAccountDocument>>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${moov_business_account}/${API_DICTIONARY.FILES}`,
    method: HTTP_METHODS.GET
  })

export const generateResolutionLinkRequest = async (
  moov_business_account: string,
  data: TGenerateResolutionLinkRequest
) =>
  fetcher.request<
    TGenerateResolutionLinkRequest,
    TGenerateResolutionLinkResponse
  >({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${moov_business_account}/${API_DICTIONARY.RESOLUTION_LINK}`,
    method: HTTP_METHODS.POST,
    data
  })

export const getResolutionLinkRequest = async (moov_business_account: string) =>
  fetcher.request<unknown, TGenerateResolutionLinkResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${moov_business_account}/${API_DICTIONARY.RESOLUTION_LINK}`,
    method: HTTP_METHODS.GET
  })
